"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var GooglePay = (function () {
    function GooglePay(googlePayConfig) {
        this.baseRequest = {
            apiVersion: 2,
            apiVersionMinor: 0,
        };
        this.baseCardPaymentMethod = {
            type: 'CARD',
            parameters: {
                allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                allowedCardNetworks: [
                    'AMEX',
                    'DISCOVER',
                    'INTERAC',
                    'JCB',
                    'MASTERCARD',
                    'VISA',
                ],
                billingAddressRequired: true,
                billingAddressParameters: {
                    format: 'FULL',
                    phoneNumberRequired: true,
                },
            },
        };
        this.transactionInfo = {
            countryCode: 'US',
            currencyCode: 'USD',
            totalPriceStatus: 'FINAL',
            totalPrice: '',
        };
        this.tokenizationSpecification = {
            type: 'PAYMENT_GATEWAY',
            parameters: {
                gateway: 'cardconnect',
                gatewayMerchantId: '',
            },
        };
        this.googlePayOptions = {
            environment: 'PRODUCTION',
        };
        this.paymentRequestDefaults = __assign(__assign({}, this.baseRequest), { merchantInfo: {
                merchantId: '',
            }, transactionInfo: this.transactionInfo, emailRequired: true, allowedPaymentMethods: [
                __assign(__assign({}, this.baseCardPaymentMethod), { tokenizationSpecification: this.tokenizationSpecification }),
            ] });
        this.paymentsClient = null;
        var paymentOptions = googlePayConfig.paymentOptions, cardConnectMerchantId = googlePayConfig.cardConnectMerchantId, paymentDataRequest = googlePayConfig.paymentDataRequest;
        this.tokenizationSpecification.parameters.gatewayMerchantId = cardConnectMerchantId;
        this.paymentRequest = Object.assign({}, this.paymentRequestDefaults, paymentDataRequest);
        this.googlePayOptions = Object.assign({}, this.googlePayOptions, __assign(__assign({}, paymentOptions), { merchantInfo: this.paymentRequest.merchantInfo }));
    }
    GooglePay.resolveLib = function (options) {
        var startWait = new Date();
        return new Promise(function (resolve, reject) {
            function poll() {
                if (window.google !== undefined &&
                    window.google.payments !== undefined) {
                    var paymentsClient = new google.payments.api.PaymentsClient(options);
                    resolve(paymentsClient);
                }
                else {
                    var elapsedMs = new Date().valueOf() - startWait.valueOf();
                    if (elapsedMs > 15000) {
                        reject(new Error('pay.js not loaded after 15 seconds'));
                    }
                    else {
                        setTimeout(poll, 250);
                    }
                }
            }
            poll();
        });
    };
    GooglePay.injectScript = function () {
        if (window.google !== undefined && window.google.payments !== undefined) {
            throw new Error('google payments is already injected');
        }
        var script = document.createElement('script');
        script.src = 'https://pay.google.com/gp/p/js/pay.js?render=explicit';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
    };
    GooglePay.prototype.getGoogleIsReadyToPayRequest = function () {
        return Object.assign({}, this.baseRequest, {
            allowedPaymentMethods: [this.baseCardPaymentMethod],
        });
    };
    GooglePay.prototype.getGooglePaymentClient = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!_this.paymentsClient) {
                GooglePay.resolveLib(_this.googlePayOptions)
                    .then(function (client) {
                    _this.paymentsClient = client;
                    resolve(client);
                })
                    .catch(function (err) { return reject(err); });
            }
            else {
                resolve(_this.paymentsClient);
            }
        });
    };
    GooglePay.prototype.onGooglePaymentButtonClicked = function (transactionInfoUpdate) {
        var _this = this;
        var paymentDataRequest = this.paymentRequest;
        this.transactionInfo = Object.assign({}, this.transactionInfo, transactionInfoUpdate);
        paymentDataRequest.transactionInfo = this.transactionInfo;
        return new Promise(function (resolve, reject) {
            if (!_this.paymentsClient) {
                reject('PaymentClient not initialized');
            }
            else {
                _this.paymentsClient
                    .loadPaymentData(paymentDataRequest)
                    .then(function (paymentData) {
                    resolve(paymentData);
                })
                    .catch(function (err) {
                    reject(err);
                });
            }
        });
    };
    GooglePay.prototype.tokenizeWithCardConnect = function (paymentToken, cardConnectBaseUrl) {
        return fetch(cardConnectBaseUrl + "/cardsecure/api/v1/ccn/tokenize", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                encryptionhandler: 'EC_GOOGLE_PAY',
                devicedata: paymentToken,
                unique: true,
            }),
        }).then(function (response) { return response.json(); });
    };
    return GooglePay;
}());
exports.default = GooglePay;
